import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const publisherApi = generateNomenApi<{ title: string }>(`/publishers`); // TODO SEPARATE publisher from nomen

export const publisherOptions = generateNomenOptions('publisher', publisherApi);
